import { convertToDateSlash } from '@/utils/date'
import { DATE_FORMAT } from '@/utils/constants'
import { WARRANTY_RECEPTION_STATUS_NAME } from '../../../../utils/enum-name'

export const mapWarrantyListItem = (item) => {
  const receptionDate = convertToDateSlash(item.createdAt, DATE_FORMAT)
  const statusChangeDate = convertToDateSlash(item.statusLastChangedAt, 'DD/MM/YYYY HH:mm')
  const statusName = WARRANTY_RECEPTION_STATUS_NAME[item.status] || item.status

  const warrantyRepairs = item.warrantyRepairs || [];
  const isCannotRepair = warrantyRepairs.length > 0 && warrantyRepairs.every(repair => repair.isCannotRepair);
  const isDisagreePrice = warrantyRepairs.length > 0 && warrantyRepairs.every(repair => repair.isDisagreePrice);
  return {
    ...item,
    receptionDate,
    statusChangeDate,
    statusName,
    customerName: item.customerName || '',
    phoneNumber: item.customerPhone || '',
    contactNumber: item.customerContactNumber || '',
    checked: false,
    isCannotRepair,
    isDisagreePrice,
    companyName: item.companyName || null,
    companyCode: item.companyCode || null,
  }
}

export const getExternalNoteFromTradeIn = (tradeInDetails = []) => {
  return tradeInDetails
    .sort((a, b) => a.priority - b.priority) // optional: giữ đúng thứ tự
    .map((detail) => {
      const selectedItem = (detail.listItem || []).find(
        (item) => item.selected === true || item.selected === item.id,
      )

      return selectedItem ? `- ${detail.criterialName}: ${selectedItem.name}` : null
    })
    .filter(Boolean)
    .join('\n')
}
